<template>
  <div class="p-2 d-flex flex-column gap-4">
    <McAlert
      v-if="isShowAlert"
      withIcon
      class="modal-form__alert"
      variant="info"
      :text="$t('customField.text.chooseOneFieldType')"
    >
      <template #suffix>
        <button class="clear-search-btn" @click="isShowAlert = false">
          <i class="pe-2 mc-icon icon-outline_close"></i>
        </button>
      </template>
    </McAlert>

    <template v-for="item in typeItems">
      <ModalTypeCard
        v-if="item.isShow"
        :key="item.key"
        hasHoverEffect
        :title="$t(item.title)"
        :description="$t(item.description)"
        :isSelected="typeSelected.key == item.key"
        @click="$emit('update:typeSelected', item)"
      />
    </template>
  </div>
</template>

<script>
import McAlert from '@/components/McAlert'
import ModalTypeCard from './index'

export default {
  components: {
    McAlert,
    ModalTypeCard,
  },
  inject: ['typeItems'],
  props: {
    typeSelected: {
      type: Object,
    },
  },
  emits: ['update:typeSelected'],
  data() {
    return {
      isShowAlert: true,
    }
  },
  methods: {
    handleCancel(cancel) {
      this.$emit('update:typeSelected', { key: '', title: '' })
      cancel()
    },
  },
}
</script>

<style lang="scss" scoped>
.clear-search-btn {
  border: none;
  background-color: transparent;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    color: $mep-color-text-200;
  }
}
</style>